import { inject } from '@angular/core';
import {
  callApiMethod,
  setError,
  setLoaded,
  setLoading,
  withCallState,
  withModel,
  withModelCrud,
} from '@kinet-open-network/client/shared/data-access/state';
import { apiFilter } from '@kinet-open-network/shared/data-access/api';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { CustomerAdditionalProduct } from '../models/customer-additional-product.model';
import { CustomerAdditionalProductsService } from '../services/customer-additional-products.service';

export const CustomerAdditionalProductsStore = signalStore(
  { protectedState: false },
  withCallState(),
  withModel<CustomerAdditionalProduct>(),
  withModelCrud(CustomerAdditionalProductsService),
  withState<{ data: CustomerAdditionalProduct[] }>({ data: [] }),
  withMethods((store, service = inject(CustomerAdditionalProductsService)) => ({
    loadByApId: (customerId?: number | null, apId?: string | null) => {
      if (!customerId || !apId) {
        patchState(store, { data: [] });
        return;
      }

      patchState(store, setLoading());

      return callApiMethod(
        () =>
          service.query({
            filters: apiFilter<CustomerAdditionalProduct>()
              .customerId(customerId)
              .apId(apId),
            perPage: -1,
            sort: ['createdAt'],
          }),
        {
          next: (resp) => patchState(store, { data: resp.data }, setLoaded()),
          error: (err) => patchState(store, setError(err)),
        },
      );
    },
    setActivationDate: (id: string, activationDate: Date | null) => {
      patchState(store, setLoading());
      return callApiMethod(
        () => service.setActivationDate(id, activationDate),
        {
          next: () => patchState(store, setLoaded()),
          error: (err) => patchState(store, setError(err)),
        },
      );
    },
    setDeactivationDate: (id: string, deactivationDate: Date | null) => {
      patchState(store, setLoading());
      return callApiMethod(
        () => service.setDeactivationDate(id, deactivationDate),
        {
          next: () => patchState(store, setLoaded()),
          error: (err) => patchState(store, setError(err)),
        },
      );
    },
    setInvoicingPeriod: (
      id: string,
      data: { invoiceFrom: Date | null; invoiceTo: Date | null },
    ) => {
      patchState(store, setLoading());
      return callApiMethod(() => service.setInvoicingPeriod(id, data), {
        next: () => patchState(store, setLoaded()),
        error: (err) => patchState(store, setError(err)),
      });
    },
    setInvoiceState: (id: string, invoiceDate: Date | null) => {
      patchState(store, setLoading());
      return callApiMethod(() => service.setInvoiceState(id, invoiceDate), {
        next: () => patchState(store, setLoaded()),
        error: (err) => patchState(store, setError(err)),
      });
    },
  })),
);
